// Environment variables
const config = {
    SUPABASE_URL: 'https://prcokthtfcnmjiytcpcg.supabase.co',
    SUPABASE_ANON_KEY: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InByY29rdGh0ZmNubWppeXRjcGNnIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDMwOTkwMjYsImV4cCI6MjA1ODY3NTAyNn0.Gunr9T700cH98lCpcxD7PkueaHcs0UzP344tDIawKZo',
    SPOTIFY_CLIENT_ID: '',     // Add your Spotify Client ID
    SPOTIFY_CLIENT_SECRET: '', // Add your Spotify Client Secret
    YOUTUBE_CLIENT_ID: ''      // Add your YouTube Client ID
};

export const {
    SUPABASE_URL,
    SUPABASE_ANON_KEY,
    SPOTIFY_CLIENT_ID,
    SPOTIFY_CLIENT_SECRET,
    YOUTUBE_CLIENT_ID
} = config;

export default config; 